import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageAccountEstateUpdate = async (
  id: string,
  name: string,
  mail: string,
  auth_facility: number,
  auth_list: number,
  auth_setting: number
) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/account/update`, {
        session_code: localStorage.getItem("session_code"),
        id: id,
        name: name,
        mail: mail,
        auth_facility: auth_facility,
        auth_list: auth_list,
        auth_setting: auth_setting
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
